export default "__VITE_ASSET__CVndaoPD__"